export default {
  A: 'Authorised',
  AWD: 'Authority Withdrawn',
  AWH: 'Authority Withheld',
  CS: 'Cash Settlement',
  QR: 'Quoted',
  TLD: 'Total Loss Determined',
  TLR: 'Total Loss Requested'
}
